// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"a416c898","895":"8cecd34c"}[chunkId] + ".chunk.js";
};